import { useTranslation } from 'react-i18next';
import ProductCard from '../main_compos/ProductCard';
import { useEffect, useState } from 'react';
import axios from 'axios';

export default function ProductList() {
  const { t } = useTranslation();
  const localhost = process.env.REACT_APP_LOCALHOST;
  const [products, setproducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(localhost + "home-product-list");
      const data = res.data;

      const updatedData = data.map(item => {
        const category = item.category ? JSON.parse(item.category) : null;
        const imgs = item.imgs ? JSON.parse(item.imgs) : null;
        return { ...item, category, imgs };
      });
      setproducts(updatedData);
      setLoading(false);
    } catch (error) {
      // console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  if (loading) {
    return (
      <div className="min-h-[55vh] flex justify-center items-center">
        <div className="loading-spinner" />
      </div>
    );
  }

  return (
    <section className="py-12 sm:py-16 lg:py-20 max-sm:px-4">
      <div className="container mx-auto">
        <div className="">
          <h2 className="text-2xl max-sm:text-xl font-bold text-gray-900 sm:text-3xl">{t("new-products")}</h2>
          <p className="text-base max-sm:text-sm text-gray-600">{t("our-new-collection")}</p>
        </div>
        <div className="grid grid-cols-2 gap-6 mt-4 lg:gap-4 lg:grid-cols-4">
          {products.map((item, index) => (
            <ProductCard key={index} item={item} />
          ))}
        </div>
      </div>

      <div className='w-full flex justify-center items-center mt-10'>
        <a href="/shop" className='px-4 py-2 text-sm text-white bg-black rounded-lg hover:bg-black/80 transition-all duration-300'>
          {t("view-all")}
        </a>
      </div>
    </section>
  );
}
